// All used colors
/*export const graphColors = [
    {"Flame":"dc5b17"},
    {"incoming":"f26419"}, // incoming
    #F3712B -> lighter orange
    {"Olive":"998236"},
    {"hover":"40a052"}, // hover node
    {"Myrtle Green":"3a776e"},
    {"outgoing":"465e95"}, // outgoing
    {"Blue 2":"334e8a"} 
]*/

export const hoverColors = {
    hover: "#40a052", // green
    hover2: "#39F28C", // dark green
    incoming: "#F3712B", // orange
    incoming2: "f26419", // dark orange ?
    outgoing: "#465e95", // blue
    outgoing2: "#334e8a", //  dark blue
    resource: "998236", // Change
}

// greys
export const nodeColors = {
    white: "white", 
    lightgrey: "#eeeeee",
    lightgrey05: "#dddddd",
    lightgrey2: "#d4d1d1",
    grey1: "#a6a2a2",
    grey: "#858383",
    darkgrey: "#3e3e3e",
    darkgrey2: "#232323",
}

// purples (greyish)
export const connectColors = {
    target: "#3c3245", //483c53
    tBorder: "#c28ffc", // #c5a8e6
    close: "#60506f", //60506f  //#483c53
    far: "#bcadcc", //a093ad
}